<template>
    <teleport to="body">
        <van-action-bar>
            <van-action-bar-icon icon="description" text="预约报名" @click="onClickIcon"/>
            <van-action-bar-button icon="service" type="danger" text="在线咨询" @click="onClickButton"/>
            <van-action-bar-button icon="phone" color="#7232dd" type="danger" text="电话沟通"
                                   @click="onCallPhone"/>
        </van-action-bar>
        <van-popup
                v-model:show="show"
                closeable
                close-icon="close"
                position="bottom"
                :style="{ height: '302px' }"
        >
            <Bm :purpose_school="purpose_school" :source="source" :bg_color="bg_color" :btn_color="btn_color"></Bm>

        </van-popup>
    </teleport>
</template>
<script>
import {ref} from 'vue';
import Bm from "@/components/Bm.vue";
import open53 from "@/api/seviceBtn"
export default {
    name: 'BottomComponent',
    components: {
        Bm
    },
    props: {
        phone: {
            type: String,
            default: '13971355534'
        },
        bg_color: {
            type: String,
            default: '#e42127'
        },
        btn_color: {
            type: String,
            default: 'rgb(114, 50, 221)'
        },
        purpose_school: {
            type: [String, Number],
            default: ''
        },
        source: {
            type: [String, Number],
            default: ''
        },
        affim: {
            type: String,
            default: ''
        }
    },
    setup(props) {
        const show = ref(false)
        const onClickIcon = () => {
            show.value = true
        };
        const onClickButton = () => {
            open53(props.affim)
        }

        function onCallPhone() {
            window.location.href = 'tel:' + props.phone;
        }

        return {
            show,
            onClickIcon,
            onClickButton,
            onCallPhone
        }
    }
}
</script>
<style scoped>

</style>
